<template>
  <div>이용약관 준비중입니다.</div>
</template>

<script>
export default {};
</script>
